module.exports = __webpack_public_path__ + "img/step6-10.774b8bc2.jpg";